import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home/Home';
import Snapshot from '../pages/Snapshot/Snapshot';
import SnapshotRequest from '../pages/Snapshot/SnapshotRequest';
import StateChangeData from '../pages/Snapshot/StateChangeData';
 

const Router = ({ isSnapshot }) => {

    return (
        <Routes>
            <Route path='/' element={<Home isSnapshotAccess={isSnapshot}/>} />
            <Route path='/snapshot' element={<Snapshot />} />
            <Route path='/snapshot/snapshot-request' element={<SnapshotRequest />} />
            <Route path='/snapshot/state-change-data' element={<StateChangeData />} />


        </Routes>
    )
}
// implement nested route
export default Router


